import React, { FunctionComponent } from 'react'
import { G, Path, Rect, Svg } from 'react-native-svg'

export const SideNavToDoIcon: FunctionComponent<SideNavToDoIconProps> = ({
  size = 32,
  fillColor,
  isFilled = false,
}) => {
  return (
    <Svg width={size} height={size} fill='none'>
      {isFilled ? (
        <path
          xmlns='http://www.w3.org/2000/svg'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.33333 3C5.38781 3 3 5.38782 3 8.33334V24C3 26.9455 5.38782 29.3333 8.33334 29.3333H24C26.9455 29.3333 29.3333 26.9455 29.3333 24V8.33333C29.3333 5.38781 26.9455 3 24 3H8.33333ZM16.8021 10.0898H7.76859C7.27174 10.0898 6.86523 10.4964 6.86523 10.9932C6.86523 11.49 7.27174 11.8965 7.76859 11.8965H16.8021C17.299 11.8965 17.7055 11.49 17.7055 10.9932C17.7055 10.4964 17.299 10.0898 16.8021 10.0898ZM16.8021 13.7031H7.76859C7.27174 13.7031 6.86523 14.1096 6.86523 14.6065C6.86523 15.1033 7.27174 15.5098 7.76859 15.5098H16.8021C17.299 15.5098 17.7055 15.1033 17.7055 14.6065C17.7055 14.1096 17.299 13.7031 16.8021 13.7031ZM13.1887 19.1235H7.76859C7.27174 19.1235 6.86523 18.717 6.86523 18.2201C6.86523 17.7233 7.27174 17.3168 7.76859 17.3168H13.1887C13.6855 17.3168 14.0921 17.7233 14.0921 18.2201C14.0921 18.717 13.6855 19.1235 13.1887 19.1235ZM25.1227 15.6996L25.204 15.7809C25.5563 16.1332 25.5563 16.7024 25.204 17.0547L20.1633 22.1044C19.811 22.4567 19.2419 22.4567 18.8896 22.1044L16.0982 19.313C15.929 19.1443 15.834 18.9151 15.834 18.6762C15.834 18.4372 15.929 18.2081 16.0982 18.0393L16.1795 17.958C16.5318 17.6057 17.1009 17.6057 17.4532 17.958L19.5309 20.0357L23.849 15.7087C24.1922 15.3473 24.7704 15.3473 25.1227 15.6996Z'
          fill={fillColor}
        />
      ) : (
        <G>
          <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.5878 10.8205H17.2783C17.7563 10.8205 18.1473 11.2116 18.1473 11.6895C18.1473 12.1675 17.7563 12.5586 17.2783 12.5586H8.5878C8.10982 12.5586 7.71875 12.1675 7.71875 11.6895C7.71875 11.2116 8.10982 10.8205 8.5878 10.8205ZM8.5878 14.2966H17.2783C17.7563 14.2966 18.1473 14.6877 18.1473 15.1657C18.1473 15.6436 17.7563 16.0347 17.2783 16.0347H8.5878C8.10982 16.0347 7.71875 15.6436 7.71875 15.1657C7.71875 14.6877 8.10982 14.2966 8.5878 14.2966ZM8.5878 19.5111H13.8021C14.2801 19.5111 14.6711 19.12 14.6711 18.6421C14.6711 18.1641 14.2801 17.773 13.8021 17.773H8.5878C8.10982 17.773 7.71875 18.1641 7.71875 18.6421C7.71875 19.12 8.10982 19.5111 8.5878 19.5111ZM25.3618 16.2954L25.2836 16.2172C24.9447 15.8782 24.3885 15.8782 24.0583 16.2259L19.9042 20.3886L17.9054 18.3898C17.5665 18.0509 17.019 18.0509 16.6801 18.3898L16.6018 18.468C16.4391 18.6304 16.3477 18.8508 16.3477 19.0807C16.3477 19.3106 16.4391 19.531 16.6018 19.6934L19.2872 22.3787C19.6261 22.7176 20.1736 22.7176 20.5126 22.3787L25.3618 17.5207C25.7008 17.1818 25.7008 16.6343 25.3618 16.2954Z'
            fill={fillColor}
          />
          <Rect x='4' y='4' width='24' height='24' rx='4.33333' stroke={fillColor} stroke-width='2' />
        </G>
      )}
    </Svg>
  )
}

export type SideNavToDoIconProps = {
  size?: string | number
  fillColor?: string
  isFilled?: boolean
}
